// extracted by mini-css-extract-plugin
export default {"actions":"Confirm_actions__HiiFi"};